export default function KeybindsTab() {
    return (
        <h2>Keybinds</h2>
    );
}